import axios from 'axios'
import store from '@/store'
import Qs from 'qs'
import { getToken } from './auth'
import constv from '@/config/constv'
import { message as Message } from 'ant-design-vue/es'
const service = axios.create({
  baseURL: `${constv.API_URL}`,
  timeout: 20000,
  transformRequest: params => Qs.stringify(params) // 参数格式化 qs.stringify({ a: ['b', 'c'] }, { arrayFormat: 'repeat' }) => 'a=b&a=c'
  // paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }) // 参数格式化 qs.stringify({ a: ['b', 'c'] }, { arrayFormat: 'repeat' }) => 'a=b&a=c'
})

// 自定义toast文案 当包含下面错误码是不弹接口返回的message
const whiteListCode = [1006, 1007] // 1006:验证码超过5次， 1007: 账号或者密码错误或者验证码错误

const err = error => {
  return Promise.reject(error)
}

service.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers['MAuthorization'] = 'b2ce5f4a52637000ad461899e5ea4a24:' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

service.interceptors.response.use(response => {
  const result = response.data
  const message = result.message
  if (response.status === 200) {
    if (result.message.key === 1009) { // token 过期
      store.dispatch('Logout').then(() => {
        setTimeout(() => {
          window.location.reload()
        }, 0)
      })
    }
    if (result.status === 'error') {
      if (whiteListCode.includes(result.message.key)) {

      } else {
        Message.error(message.message)
      }
      return Promise.resolve(result)
    }
    if (result.status === 'ok') {
      return Promise.resolve(result)
    }
  } else {
    return Promise.reject(response)
  }
}, err)

export { service, axios }
